import * as React from "react";
import { Info } from "lucide-react";
interface NotificationProps {
  type: "alert" | "info";
  message: string;
  link?: string;
}
export const Notification: React.FC<NotificationProps> = ({
  type,
  message,
  link
}) => {
  let bgColor, textColor, borderColor;
  if (type === "alert") {
    bgColor = "bg-yellow-300/30";
    textColor = "text-yellow-900 dark:text-yellow-100";
    borderColor = "border-yellow-500/50";
  } else {
    bgColor = "bg-blue-200/20";
    textColor = "text-blue-600 dark:text-blue-300";
    borderColor = "border-blue-500/20";
  }
  return <div className={`flex items-center justify-between rounded-2xl p-4 shadow-md ${bgColor} ${textColor} border ${borderColor}`} data-sentry-component="Notification" data-sentry-source-file="Notification.tsx">
      <div className="flex items-center gap-3">
        <Info size={20} className="min-w-[20px]" data-sentry-element="Info" data-sentry-source-file="Notification.tsx" />
        <span>
          {message}{" "}
          {link && <a href={link} className="underline">
              {link}
            </a>}
        </span>
      </div>
    </div>;
};